import { render, staticRenderFns } from "./SliderMainBlok.vue?vue&type=template&id=12837e15&scoped=true&"
import script from "./SliderMainBlok.vue?vue&type=script&lang=ts&"
export * from "./SliderMainBlok.vue?vue&type=script&lang=ts&"
import style0 from "./SliderMainBlok.vue?vue&type=style&index=0&id=12837e15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12837e15",
  null
  
)

export default component.exports